import { Link } from "react-router-dom";

import Seo from "../../components/Seo";
import { seoFromPublicPage } from "../../seo/publicPages";
import ArticleLayout from "./ArticleLayout";

export default function RegulamentInternAutoturismPage() {
  return (
    <>
      <Seo {...seoFromPublicPage("/regulament-intern-autoturism")} />
      <ArticleLayout
        eyebrow="Pentru 100%"
        title="Regulament intern pentru autoturismul de firmă"
        lead="Foaia de parcurs arată unde a mers mașina. Regulamentul arată că folosirea personală e interzisă. La 100%, inspectorul le vrea pe amândouă — nu un PDF de zece pagini semnat ieri."
      >
        <p>
          Dacă pretinzi <strong>deducere 100%</strong> pe un autoturism sub 3,5 tone, foaia
          de parcurs nu e suficientă. Îți trebuie și un <strong>regulament intern</strong>{" "}
          (sau o politică auto) care interzice folosirea personală și e semnat de cei care
          conduc mașina. Fără el, <strong>50%</strong> rămâne varianta mai sigură.
        </p>

        <h2>Când îți trebuie, de fapt</h2>
        <p>
          Regulamentul nu e un formular ANAF și nu există un model obligatoriu. Ce contează
          e că firma a stabilit, <strong>în scris și înainte de perioada verificată</strong>,
          că mașina e pentru activitate — nu pentru weekend și drumul la mall.
        </p>
        <p>
          La <strong>50%</strong> nu e piesa centrală: ai recunoscut deja o utilizare mixtă.
          La <strong>100%</strong>, inspectorul întreabă concret: ce regulă interzice
          folosirea personală și cine a semnat-o? Diferența dintre cele două regimuri e în{" "}
          <Link to="/deducere-100-combustibil">articolul despre deducerea 100%</Link>. Aici
          e doar documentul de reguli.
        </p>
        <p>
          Regulamentul <strong>nu înlocuiește foaia</strong>. Regulamentul spune „ce e
          permis”. Foaia arată „ce s-a întâmplat”. Dacă se contrazic — reguli de utilizare
          exclusiv economică, dar curse de sâmbătă pe foaie — cade 100%.
        </p>

        <h2>Ce trebuie să conțină — o pagină e destul</h2>
        <p>
          Nu contează volumul, ci faptul că se aplică. Un regulament de o pagină, respectat,
          ține mai bine decât zece pagini copiate de pe internet. Minimul util:
        </p>
        <div className="article-doc__table-wrap">
          <table className="article-doc__table">
            <thead>
              <tr>
                <th>Clauză</th>
                <th>De ce e acolo</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Cine poate conduce</td>
                <td>Administrator și angajați nominalizați — nu „oricine din familie”.</td>
              </tr>
              <tr>
                <td>Interdicția folosirii personale</td>
                <td>Weekend, vacanță și naveta casă–sediu, dacă nu e traseu de lucru.</td>
              </tr>
              <tr>
                <td>Ce înseamnă deplasare de serviciu</td>
                <td>Client, furnizor, instituție — nu „diverse”.</td>
              </tr>
              <tr>
                <td>Obligația foii de parcurs</td>
                <td>Completare lunară, cu cele 4 elemente.</td>
              </tr>
              <tr>
                <td>Abateri</td>
                <td>Ce se întâmplă dacă mașina e folosită în alt scop.</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p>
          Pe prima pagină: data, CUI-ul, numărul de înmatriculare și cine aprobă. Dedesubt,
          semnăturile celor care conduc. Un regulament pe care nu l-a citit și semnat nimeni
          rămâne hârtie goală.
        </p>

        <h2>Ce cade la control</h2>
        <p>
          Inspectorul nu caută un document frumos. Caută coerența dintre reguli și ce s-a
          întâmplat cu mașina.
        </p>
        <div className="article-doc__callout article-doc__callout--warning">
          <strong>De evitat</strong>
          <ul>
            <li>Regulament care permite folosirea personală, dar tu pretinzi 100%.</li>
            <li>Model copiat de pe internet, fără mașina și persoanele tale.</li>
            <li>Semnat în ajunul controlului, pentru trei ani în urmă.</li>
            <li>Foaie cu curse de sâmbătă, regulament cu „exclusiv economic”.</li>
          </ul>
        </div>

        <h2>Regulamentul nu ține loc de comodat</h2>
        <p>
          Dacă mașina e înmatriculată pe persoană fizică, regulamentul nu rezolvă dreptul de
          folosință. Primul document e contractul de comodat. Cazul e în{" "}
          <Link to="/masina-personala-srl-comodat">
            articolul despre mașina personală folosită de SRL
          </Link>
          . Regulamentul vine după, ca să arate că folosirea e exclusiv economică.
        </p>
        <p>
          Păstrează-l în același dosar cu foile, talonul, RCA-ul și, dacă e cazul,
          comodatul. În{" "}
          <Link to="/control-anaf-cheltuieli-autoturism">
            ghidul despre controlul ANAF pe cheltuieli auto
          </Link>{" "}
          e în checklist. Nu trebuie să fie lung. Trebuie să fie aplicat.
        </p>

        <h2>Concluzie</h2>
        <p>
          Regulamentul spune, în scris, că mașina firmei nu se folosește personal. Nu
          înlocuiește foaia și nu ține loc de comodat.
        </p>
        <p>
          <strong>Vrei 100%.</strong> Ai regulament de o pagină, semnat înainte de perioada
          pe care o deduci, cu interdicție clară. Foaia lunară confirmă că regula s-a
          respectat. Cele două spun același lucru.
        </p>
        <p>
          <strong>Rămâi la 50%.</strong> Nu forța un regulament de „exclusiv economic” peste
          curse personale. Regimul de 50% e făcut pentru utilizarea mixtă, iar inspectorul
          îl acceptă fără această piesă.
        </p>
        <p>
          Când regulamentul e semnat la timp și foaia nu îl contrazice, inspectorul are un
          răspuns simplu: firma a interzis folosirea personală, iar km-ii de pe foaie sunt
          de serviciu. Subiectul e închis. Poți trece la treabă.
        </p>
      </ArticleLayout>
    </>
  );
}
